import { transactionApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param  {Object} getters
   * @param {String} id
   * @param {Boolean} isOpen
   */
  async initRBTMDetail({ commit, dispatch, getters }, id) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchDetail', id),
      dispatch('fetchRules'),
      dispatch('fetchStatuses'),
      dispatch('fetchTypes'),
    ];
    await Promise.all(requests);
    if (getters['isOpen']) {
      await dispatch('takeCare', id);
    }
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} id
   */
  async takeCare({ commit, rootGetters }, id) {
    const token = rootGetters['auth/token'];
    try {
      await transactionApi.requestTake(token, id);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} id
   */
  async fetchDetail({ commit, rootGetters }, id) {
    const token = rootGetters['auth/token'];
    try {
      const response = await transactionApi.requestDetail(token, id);
      commit('setDetail', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchRules({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await transactionApi.requestRules(token);
      commit('setRules', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchStatuses({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await transactionApi.requestStatuses(token);
      commit('setStatuses', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchTypes({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await transactionApi.requestAlarmTypes(token);
      commit('setTypes', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} transactionId
   * @param {Object} data
   */
  async updateState({ commit, rootGetters }, { transactionId, data }) {
    const token = rootGetters['auth/token'];
    try {
      await transactionApi.requestUpdate({ token, transactionId, data });
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
